import { defineFcm } from '../shared/factory';

export const FCM_ENABLE_BLACK_HISTORY_LOGO = defineFcm('enable_black_history_logo')
	.asBoolean()
	.withDefault(false)
	.toConfig();
